// extracted by mini-css-extract-plugin
export default {"root":"VehicleNavigationBar-root","scrollView":"VehicleNavigationBar-scrollView","jiggle-horizontal":"VehicleNavigationBar-jiggle-horizontal"};